module.exports = __webpack_public_path__ + "static/img/2.ed5069d8.webp";